import { load as loadBase, init as initBase, detectFace as detectFaceBase } from './faceDetectionWorkerBase';

export default class FaceDetectionFakeWorker {
  private faceModel: any;

  public async load() {
    await loadBase();
  }

  public async init(data: any) {
    this.faceModel = await initBase(data);
  }

  public async detectFace(data: any) {
    return detectFaceBase(data, this.faceModel);
  }
}
